export default __webpack_public_path__ + "static/media/StudioC-logo.6d3a9721.png";